import dayjs from 'dayjs';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useRouterFilters from 'hooks/useRouterFilters';

import { ADVANCE_WMS_MODULE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

const BinTransactions = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'id', filterType: FilterType.number, show: false, width: 10 },
			{ Header: 'orderID', accessor: 'incrementId', filterType: FilterType.string, width: 30 },
			{ Header: 'binName', accessor: 'binName', filterType: FilterType.multiSelection, width: 30 },
			{ Header: 'productName', accessor: 'productName', filterType: FilterType.string, width: 30 },
			{ Header: 'sku', accessor: 'sku', filterType: FilterType.string, width: 30 },
			{ Header: 'action', accessor: 'action', filterType: FilterType.multiSelection, width: 30 },
			{ Header: 'previousQTY', accessor: 'previousQTY', filterType: FilterType.float, width: 30 },
			{ Header: 'changedQTY', accessor: 'changedQTY', filterType: FilterType.float, width: 30 },
			{ Header: 'newQTY', accessor: 'newQTY', filterType: FilterType.float, width: 30 },
			{
				Header: 'waveId',
				accessor: 'waveID',
				filterType: FilterType.number,
				roleName: 'WMS_BinTracking',
				width: 30
			},
			{
				Header: 'actionDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				filterRemovable: false,
				width: 30
			},
			{ Header: 'doneBy', accessor: 'userName', filterType: FilterType.multiSelection, width: 30 }
		],
		[]
	);
	const defaultFilters = useMemo(
		() => [
			{
				column: columns.find((c) => c.accessor === 'createdDate'),
				action: FilterAction.between,
				value: {
					start: dayjs().subtract(30, 'day').endOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		],
		[]
	);

	const filtersFromRouter = useRouterFilters(columns);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="binTransactions"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.OTO_PACK_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList
				id={DYNAMICLISTS.BIN_TRANSACTIONS}
				columns={columns}
				fetchUrl={ADVANCE_WMS_MODULE.GET_BIN_TRANSACTIONS_LIST}
				defaultFilters={filtersFromRouter ?? defaultFilters}
				exportName="binTransactions"
				actionObjectType={ACTION_OBJECT_TYPES.WMS}
			/>
		</div>
	);
};

export default BinTransactions;
